export default __webpack_public_path__ + "static/media/m_wdt_c_4.c81ba302.mp3";